import { TextWithTooltip } from '@payright/web-components';
import React, { ReactNode } from 'react';

type WhatsThisTooltipProps = {
  content: ReactNode;
};

export const WhatsThisTooltip = ({ content }: WhatsThisTooltipProps) => (
  <TextWithTooltip content={content}>What's this?</TextWithTooltip>
);
